export const additionalQueriestableHeadings01 = {
  Metrics: "Metric",
  Actual: "Actual",
  Target: "Target",
  Attainment: "Attainment",
  Gap: "Gap",
};

export const additionalQueriesrows01 = [
  {
    metric: "spend",
    name: "Spend",
  },
  {
    metric: "clicks",
    name: "Clicks",
  },
  {
    metric: "cpc",
    name: "CPC",
  },
  {
    metric: "ftd",
    name: "FTD",
  },
  {
    metric: "cvr",
    name: "CVR%",
  },
  {
    metric: "CAC",
    name: "CAC",
  },
  {
    metric: "profit",
    name: "Profit",
  },
  {
    metric: "NRPU",
    name: "NRPU",
  },
  {
    metric: "CPA_Income",
    name: "CPA Income",
  },
  {
    metric: "RS_Income",
    name: "RS Income",
  },
  {
    metric: "RS_Income",
    name: "RS Income",
  },
  {
    metric: "TOTAL_Income",
    name: "Total Income",
  },
  {
    metric: "CPA_PV",
    name: "CPA PV",
  },
  {
    metric: "RS_PV",
    name: "RS PV",
  },
  {
    metric: "pv",
    name: "PV",
  },
];

export const additionalQueriestableHeadings02 = {
  Metrics: "Metric",
  Last_week: "Last 7 Days",
  Last_two_week: "7 - 14 Days",
  Trend: "Trend",
};

export const additionalQueriesrows02 = [
  {
    metric: "FTD",
  },
  {
    metric: "CPC",
  },
  {
    metric: "Profit",
  },
  {
    metric: "Spend",
  },
  {
    metric: "CVR",
  },
  {
    metric: "CAC",
  },
  {
    metric: "CPA_PV",
  },
  {
    metric: "Rs_pv",
  },
];

export const brandPerformanceAll = [
  { key: "Run", label: "Run" },
  { key: "brand_id", label: "Brand ID" },
  { key: "brand", label: "Brand Name" },
  { key: "clicks", label: "Click Out" },
  { key: "reg", label: "Registrations" },
  { key: "ftd", label: "FTD" },
  { key: "qftd", label: "QFTD" },
  { key: "ftd_perc", label: "%FTD" },
  { key: "qftd_perc", label: "%QFTD" },
  { key: "cpa_income_usd", label: "Cpa Income (USD)" },
  { key: "revshare_income_usd", label: "Rs Income (USD)" },
  { key: "total_income_usd", label: "Total Income (USD)" },
  // Net Revenue is not returned as its own column — the API exposes it as `netrev`
  { key: "netrev", label: "Net Revenue" },
  { key: "pv", label: "PV (USD)" },
  { key: "epc", label: "EPC (USD)" },
  { key: "epc_cpa", label: "EPC CPA (USD)" },
  { key: "roi", label: "ROI%" },
];
export const brandPerformanceAllMobile = [
  { key: "brand_id", label: "Brand ID" },
  { key: "brand", label: "Brand Name" },
  { key: "clicks", label: "Click Out" },
  { key: "reg", label: "Registrations" },
  { key: "ftd", label: "FTD" },
  { key: "qftd", label: "QFTD" },
  { key: "ftd_perc", label: "%FTD" },
  { key: "qftd_perc", label: "%QFTD" },
  { key: "cpa_income_usd", label: "Cpa Income (USD)" },
  { key: "revshare_income_usd", label: "Rs Income (USD)" },
  { key: "total_income_usd", label: "Total Income (USD)" },
  { key: "pv", label: "PV (USD)" },
  { key: "epc", label: "EPC (USD)" },
  { key: "epc_cpa", label: "EPC CPA (USD)" },
  { key: "roi", label: "ROI%" },
];

export const topKeywordsForMobile = [
  { key: "kw_name", label: "KeyWord Name" },
  { key: "matchtype", label: "Match Type" },
  { key: "adgroup_name", label: "Ad Group" },
  { key: "campaign_name", label: "Campaign" },
  { key: "traffic_source", label: "Traffic Source" },
  { key: "tier", label: "Tier" },
  { key: "cost", label: "Cost (USD)" },
  { key: "imp_share", label: "Impression Share" },
  { key: "FTD", label: "FTD" },
  { key: "CAC", label: "CAC" },
  { key: "CVR", label: "CVR %" },
];

export const brandPerformanceUserBehavior = [
  { key: "brand_id", label: "Brand ID" },
  { key: "brand", label: "Brand Name" },
  { key: "clicks", label: "Click Out" },
  { key: "reg", label: "Registrations" },
  { key: "ftd", label: "FTD" },
  { key: "qftd", label: "QFTD" },
  { key: "ftd_perc", label: "%FTD" },
  { key: "qftd_perc", label: "%QFTD" },
];

export const brandPerformanceIncome = [
  { key: "brand_id", label: "Brand ID" },
  { key: "brand", label: "Brand Name" },
  { key: "cpa_income_usd", label: "Cpa Income (USD)" },
  { key: "revshare_income_usd", label: "Rs Income (USD)" },
  { key: "total_income_usd", label: "Total Income (USD)" },
];

export const brandPerformancePerformance = [
  { key: "brand_id", label: "Brand ID" },
  { key: "brand", label: "Brand Name" },
  { key: "netrev", label: "Net Revenue" },
  { key: "pv", label: "PV (USD)" },
  { key: "epc", label: "EPC (USD)" },
  { key: "epc_cpa", label: "EPC CPA (USD)" },
  { key: "roi", label: "ROI%" },
];

// Brand Performance (desktop) cells that open the Deep View drawer on click
export const brandPerformanceDeepViewColumns = new Set([
  "clicks",
  "reg",
  "ftd",
  "qftd",
  "cpa_income_usd",
  "revshare_income_usd",
  "total_income_usd",
  "netrev",
]);

export const additionalQueriestableHeadings04 = {
  brand_id: "Brand ID",
  brand: "Brand Name",
  qftd: "QFTD",
  qftd_budget: "QFTD Budget",
  perc_Qftd_budget_use: "% QFTD Budget Use",
  Qftd_RR: "RR QFTD ",
  perc_of_RR_qftd_budget_use: "% RR QFTD Budget Use",
};

export const additionalQueriestableHeadings05 = {
  kw_name: "KeyWord Name",
  matchtype: "Match Type",
  adgroup_name: "Ad Group",
  campaign_name: "Campaign",
  traffic_source: "Traffic Source",
  tier: "Tier",
  cost: "Cost (USD)",
  imp_share: "Impression Share",
  FTD: "FTD",
  CAC: "CAC",
  CVR: "CVR %",
};

export const additionalQueriestableHeadings06 = {
  brand_action_date: "Date",
  Total_ftd: "Total FTD",
  FTD_loaded: "FTD Loaded",
  perc_loaded_from_total: "FTD % Loaded from Total",
  Total_Qftd: "Total QFTD",
  QFTD_loaded: "QFTD Loaded",
  Qftd_perc_loaded_from_total: "QFTD % Loaded from Total",
};

// site performance
export const sitePerformanceAll = [
  { key: "date", label: "Date" },
  { key: "spend", label: "Spend (USD)" },
  { key: "click_in", label: "Click In" },
  { key: "cpc", label: "CPC" },
  { key: "click_out", label: "Click Out" },
  { key: "br_ftd", label: "BR FTD" },
  { key: "ng_ftd", label: "NG FTD" },
  { key: "ftd_incent", label: "FTD Incent" },
  { key: "ng_ftd_br_ftd", label: "BR FTD VS NG FTD" },
  { key: "qftds", label: "QFTD" },
  { key: "cvr", label: "CVR%" },
  { key: "cvr_without_incent", label: "CVR_Without_Incent" },
  { key: "cpa_income_dollar", label: "CPA Income (USD)" },
  { key: "rs_income_dollar", label: "RS Income (USD)" },
  { key: "total_income_dollar", label: "Total Income (USD)" },
  { key: "profit", label: "Profit (USD)" },
  { key: "cac", label: "CAC" },
  { key: "cpa_pv", label: "CPA PV" },
  { key: "rs_pv", label: "RS PV" },
  { key: "cpa_pv_qftd", label: "CPA PV QFTD" },
  { key: "epc_click_in", label: "EPC Click in" },
  { key: "roi_perc", label: "ROI" },
  { key: "rs_perc_from_total_income", label: "% RS From Total Income" },
];

export const sitePerformanceUserBehavior = [
  { key: "date", label: "Date" },
  { key: "spend", label: "Spend (USD)" },
  { key: "click_in", label: "Click In" },
  { key: "cpc", label: "CPC" },
  { key: "click_out", label: "Click Out" },
  { key: "reg", label: "REG" },
  { key: "br_ftd", label: "BR FTD" },
  { key: "ng_ftd", label: "NG FTD" },
  { key: "ng_ftd_br_ftd", label: "BR FTD VS NG FTD" },
  { key: "qftds", label: "QFTD" },
  { key: "cvr", label: "CVR%" },
];

export const sitePerformanceIncome = [
  { key: "date", label: "Date" },
  { key: "cpa_income_dollar", label: "CPA Income (USD)" },
  { key: "rs_income_dollar", label: "RS Income (USD)" },
  { key: "total_income_dollar", label: "Total Income (USD)" },
  { key: "profit", label: "Profit (USD)" },
];

export const sitePerformancePerdformance = [
  { key: "date", label: "Date" },
  { key: "cac", label: "CAC" },
  { key: "cpa_pv", label: "CPA PV" },
  { key: "cpa_pv_qftd", label: "CPA PV QFTD" },
  { key: "epc_click_in", label: "EPC Click in" },
  { key: "pv", label: "PV" },
  { key: "roi_perc", label: "ROI" },
  { key: "rs_perc_from_total_income", label: "% RS From Total Income" },
];

export const additionalQueriesrows07 = [
  {
    day_date: "Thursday 26/09/24",
    spend: "0",
    click_in: "0",
    cpc: "0",
    click_out: "12",
    br_ftd: "1",
    ng_ftd: "0",
    br_ftd_ng_ftd: "0%",
    qftd: "1",
    cvr: "0%",
  },
];
